import { internalAxios } from '../utils/axios/internal';

export const get = async () => {
  const response = await internalAxios.get('/api/contact/get.json');
  return response.data;
};
